module.exports = __webpack_public_path__ + "images/residential-icon-54ee7cc5e7544a00d80197a78b5ee5fb.svg";